import { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { getMessage } from '@gef-ui/localization/messages';
import TriangleExclamation from '@gef-ui/material-icons/TriangleExclamation';

import { AnimatedBin } from 'components';

export const TemplateTableRow = ({ id, name, onDelete, onSelect, selectable }) => {
	const [active, setActive] = useState(false);

	const handleClick = useCallback(() => {
		setActive(!active);
	}, [active]);

	const handleDelete = useCallback(() => {
		onDelete(id);
	}, [onDelete, id]);

	const handleTemplateSelect = useCallback(() => {
		onSelect && onSelect(id);
	}, [onSelect, id]);

	return (
		<Stack
			direction="row"
			sx={{
				overflow: 'hidden',
				height: '50px',
				position: 'relative',
				alignItems: 'center',
			}}
		>
			<Stack
				direction="row"
				spacing={1}
				sx={{
					transition: 'ease 1s',
					opacity: active ? 100 : 0,
					ml: active ? '0px' : '-250px',
					alignItems: 'center',
				}}
			>
				<IconButton disableRipple>
					<TriangleExclamation sx={{ color: 'primary.main' }} />
				</IconButton>
				<Typography sx={{ color: 'primary.main', fontSize: 13 }}>
					{getMessage('templates:deleteTemplate')}
				</Typography>
			</Stack>
			<Link
				sx={{
					ml: 2,
					cursor: selectable ? 'pointer' : 'default',
					color: selectable ? 'primary.main' : 'common.black',
				}}
				underline="none"
				onClick={handleTemplateSelect}
				data-id={id}
			>
				{name}
			</Link>
			<Box
				sx={{
					transition: 'ease 1s',
					pr: '20px',
					right: active ? '-40px' : 0,
					position: 'absolute',
					color: 'primary.main',
				}}
			>
				<AnimatedBin mui onClick={handleClick} />
			</Box>
			<Stack
				direction="row"
				spacing={1}
				sx={{
					transition: 'ease 1s',
					position: 'absolute',
					pr: '20px',
					right: 0,
					bottom: active ? '15px' : '50px',
				}}
			>
				<Typography sx={{ cursor: 'pointer' }} variant="button" color="primary.main" onClick={handleDelete}>
					{getMessage('common:yesCapital')}
				</Typography>
				<Typography sx={{ cursor: 'pointer' }} variant="button" color="primary.main" onClick={handleClick}>
					{getMessage('common:noCapital')}
				</Typography>
			</Stack>
		</Stack>
	);
};

TemplateTableRow.propTypes = {
	id: PropTypes.number,
	name: PropTypes.string,
	onDelete: PropTypes.func,
	onSelect: PropTypes.func,
	selectable: PropTypes.bool,
};

export default TemplateTableRow;
